import ClientSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveButtons'
import ClientSaveStatus from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveStatus/ClientSaveStatus'
import { SaveArea } from './styled-components'

interface ClientTabSaveAreaProps {
  hidden: boolean
}

const ClientTabSaveArea = ({ hidden }: ClientTabSaveAreaProps) => {
  if (hidden) return null

  return (
    <SaveArea>
      <ClientSaveStatus />
      <ClientSaveButtons />
    </SaveArea>
  )
}

export default ClientTabSaveArea
